export const animationProperties = {
  duration: 1.5,
  delay: 100,
  offset: 50,
}
